<template>
  <div class="pageDiv">
    <v-card class="" v-if="!$AuthSvc.isLogin() || !$AuthSvc.isAdmin()"">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Config Admin</span>
      </v-card-title>
      Must login as ADMIN to view data
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin() && $AuthSvc.isAdmin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Load Images Admin</span>
      </v-card-title>

      <div style="margin-top: 20px">
        <div class="flex-container">
          <div>
            <span class="label14" style="margin-right: 12px">Choose Folder: </span>
            <select class="dropdown" v-model="folderName">
              <option value="common">common</option>
              <option value="home">home</option>
              <option value="gallery">gallery</option>
              <option value="sponsors">sponsors</option>
            </select>
            <br><br>
            <span class="label16">Choose an image:</span><br>
            <button class="simple-btn" @click="uploadSponsorImage()">
              Upload
            </button>
            <input id="choose-file-id" style="padding:5px 10px" type="file" @change="handleFileUpload( $event )"/>
          </div>
        </div>

        <div class="img-div" v-if="isImage()">
          <div class="loader" v-if="isBusy"></div>
          <v-img class="img-div" :src="selectedImage">
          </v-img>
          <br><br>
          <span class="label14">Selected File:</span> {{ selectedImage }}
        </div>

        <div  v-if="!isImage()">
          <br><br><span class="label14">View PDF: </span>
          <a :href="selectedImage">{{selectedImage}}</a>
        </div>
      </div>

      <v-card-text>
        <br>
        <div class="fileListDiv">
          <span class="label16">Common</span>
          <a class="simple-btn" @click="deleteFiles(commonList)">Delete</a>
          <ul class="ulNumber">
            <li v-for="(file, index) in commonList" :key="file">
              <input type="checkbox" style="width:16x;height:16px;margin-right: 7px;" v-model="file.isSelected">
              <a @click="selectedImage=file.fileName" :class="{selectedPic: selectedImage===file}">{{ file.fileName }}</a>
            </li>
          </ul>
          <br>

          <span class="label16">Home</span>
          <button class="simple-btn" @click="deleteFiles(homeList)">Delete</button>
          <ul class="ulNumber">
            <li v-for="(file, index) in homeList" :key="file">
              <input type="checkbox" style="width:16x;height:16px;margin-right: 7px;" v-model="file.isSelected">
              <a @click="selectedImage=file.fileName" :class="{selectedPic: selectedImage===file}">{{ file.fileName }}</a>
            </li>
          </ul>
          <br>
  
          <span class="label16">Gallery</span>
          <button class="simple-btn" @click="deleteFiles(galleryList)">Delete</button>
          <ul class="ulNumber">
            <li v-for="(file, index) in galleryList" :key="file">
              <input type="checkbox" style="width:16x;height:16px;margin-right: 7px;" v-model="file.isSelected">
              <a @click="selectedImage=file.fileName" :class="{selectedPic: selectedImage===file}">{{ file.fileName }}</a>
            </li>
          </ul>
          <br>

          <span class="label16">Sponsors</span>
          <button class="simple-btn" @click="deleteFiles(sponsorList)">Delete</button>
          <ul class="ulNumber">
            <li v-for="(file, index) in sponsorList" :key="file">
              <input type="checkbox" style="width:16x;height:16px;margin-right: 7px;" v-model="file.isSelected">
              <a @click="selectedImage=file.fileName" :class="{selectedPic: selectedImage===file}">{{ file.fileName }}</a>
            </li>
          </ul>
          <br>

          <span class="label16">Courses</span>
          <button class="simple-btn" @click="deleteFiles(sponsorList)">Delete</button>
          <ul class="ulNumber">
            <li v-for="(file, index) in courseList" :key="file">
              <input type="checkbox" style="width:16x;height:16px;margin-right: 7px;" v-model="file.isSelected">
              <a @click="selectedImage=file.fileName" :class="{selectedPic: selectedImage===file}">{{ file.fileName }}</a>
            </li>
          </ul>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import swal from 'sweetalert';

  export default {
    name: "login",
    data: () => ({
      isBusy: false,
      commonList: [],
      homeList: [],
      galleryList: [],
      sponsorList: [],
      courseList: [],
      folderName: 'common',
      selectedImage: '',
      fileName: ''
    }),
    mounted: function() {
        this.$AuthSvc.authenticated(this.load);
    },
    methods: {
      load() {
        var _this = this;

        _this.$CommandSvc.get(_this, '/admin/images/list/common',
            function (data) {
               _this.commonList = _this.makeList(data);
            },
            function (error) {
                console.log('ERROR: ' + error);
            });
        _this.$CommandSvc.get(_this, '/admin/images/list/home',
            function (data) {
               _this.homeList = _this.makeList(data);
            },
            function (error) {
                console.log('ERROR: ' + error);
            });
        _this.$CommandSvc.get(_this, '/admin/images/list/gallery_1',
            function (data) {
               _this.galleryList = _this.makeList(data);
            },
            function (error) {
                console.log('ERROR: ' + error);
            });
      _this.$CommandSvc.get(_this, '/admin/images/list/sponsors',
          function (data) {
              _this.sponsorList = _this.makeList(data);
          },
          function (error) {
              console.log('ERROR: ' + error);
          });
      _this.$CommandSvc.get(_this, '/admin/images/list/courses',
          function (data) {
              _this.courseList = _this.makeList(data);
          },
          function (error) {
              console.log('ERROR: ' + error);
          });        
      },
      isImage() {
         return !this.selectedImage.includes(".pdf");
      },
      makeList(data) {
         var newList = new Array();
         for(var i=0; i < data.length; i++) {
            var obj  = {
              "fileName" : data[i],
              "isSelected" : false
            };
            newList.push(obj);
         }
         return newList;
      },
      handleFileUpload( event ){
        this.file = event.target.files[0];
        this.fileName = this.file.name;
      },
      uploadSponsorImage() {
        var _this = this;

        _this.isBusy = true;

        let formData = new FormData();
        formData.append('file', this.file);

        this.axios.post('/admin/images/upload/' + _this.folderName + '/' + _this.fileName,
          formData,
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function() {
          _this.isBusy = false;
          document.getElementById("choose-file-id").value = "";
          swal("Success", "Image uploaded successfully.", "info")
           .then((willDelete) => {
              console.log('Loaded!!');
              window.location.reload();
           });
          console.log('SUCCESS!!');
        })
        .catch(function(error){
          _this.isBusy = false;
          swal("Problem", "Unable to load image.", "error");
          console.log('FAILURE!! ' + error);
        });
      },
      deleteFiles(list) {
        var _this = this;

        var deleteList = new Array();
        for(var i=0; i < list.length; i++) {
          if (list[i].isSelected) {
              deleteList.push(list[i].fileName);
          }
        }
        _this.isBusy = true;

        this.axios.post('/admin/delete-files', deleteList)
        .then(function() {
          _this.isBusy = false;
          swal("Success", "Files deleted successfully.", "info")
           .then((willDelete) => {
              window.location.reload();
           });
          console.log('SUCCESS!!');
        })
        .catch(function(error){
          _this.isBusy = false;
          swal("Problem", "Unable to delete files.", "error");
          console.log('FAILURE!! ' + error);
        });
      }
    }
  }

</script>

<style scoped>
   .fileListDiv {
      display: inline-block;
      width: 100%;
      height: 580px;
      border: 1px solid black;
      border-radius: 12px;
      padding: 15px;
      overflow-y: scroll;
   }

   .selectedPic {
      color: darkblue;
      font-weight: bold;
   }

   .img-div {
      display: inline-block;
      width: 100%;
      margin-top: 15px;
    }

    .simple-btn {
      padding: 2px 5px !important;
      border: 1px solid black;
      border-radius: 4px;
      margin-left: 20px;
      background-color: darkgreen;
      color: white;
      font-weight: bold;
    }

    @media (min-width: 768px) {
      .img-div {
        width: 400px !important;
      }
    }

</style>